module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__content"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7828948"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Box/BoxContent.vue
// module id = 1725
// module chunks = 1